import React from 'react';

const NumberCard: React.FC<any> = ({ number = 0, countDivClass = '' }) => {

  const numberText = () => {
    /*
     * The logic here is to keep the values to 00 in any case where the time can be invalid.
     * First check for undefined/null and if the value is a positive number using Math.sign (https://www.geeksforgeeks.org/javascript-math-sign-function/)
     * Then it checks for if the length of number is 1. If it's one we concat '0' with the number if not then we render the number as it is.
     * Then by default it'll be '00'
     */
    if (number && Math.sign(number) >= 0) {
      if (number.toString().length === 1) {
        // return ('0' + number).slice(-2);
        const numberString = ('0' + number).slice(-2).toString();
        const firstDigit = numberString.charAt(0);
        const secondDigit = numberString.charAt(1);
        // return number;
        return (
          <span className={"countElement"}>
            <span className={"position"}>
              <span className={"digit static"}>{firstDigit}</span>
            </span>
            <span className={"position"}>
              <span className={"digit static"}>{secondDigit}</span>
            </span>
          </span>
      )
      } else {
        const numberString = number.toString();
        const firstDigit = numberString.charAt(0);
        const secondDigit = numberString.charAt(1);
        // return number;
        return (
          <span className={"countElement"}>
            <span className={"position"}>
              <span className={"digit static"}>{firstDigit}</span>
            </span>
            <span className={"position"}>
              <span className={"digit static"}>{secondDigit}</span>
            </span>
          </span>
        )
      }
    } else {
      // return '00';
      return (
        <span className={"countElement"}>
          <span className={"position"}>
            <span className={"digit static"}>0</span>
          </span>
          <span className={"position"}>
            <span className={"digit static"}>0</span>
          </span>
        </span>
      )
    }
  }

  const renderNumber = () => <span className="countDays">{numberText()}</span>;

  return <div className="countdownItem">{renderNumber()}<span className={countDivClass}></span></div>;
}

export default NumberCard;
